import React, { useContext, useEffect, useState } from 'react'
import { Badge, Button, Col, Container, Modal, Row } from "react-bootstrap";
import copy from "copy-to-clipboard";
import NotificationContext, { ToastType } from 'Contexts/Notification';
import Copy from "Components/icons/copyShare";
import styled, { css } from "styled-components";
import Xtwitter from '../../assets/images/x-twitterBlue.svg';
import UserContext from 'Contexts/User';
import AppContext from 'Contexts/AppContext';
import axios from 'axios';
import moment from 'moment';

const I = styled.i`
  cursor: pointer;
  font-size:22px;
  color:#6352e9;
`;
const ShareModal: React.FC<{ shareModalShow: boolean, setShareModalShow: React.Dispatch<React.SetStateAction<boolean>>, url: string, shareText: string, closeAction?: () => void, addPaxWalletPop?: any, setAddPaxWalletPop?: any, hedingText?: string }> = ({ shareModalShow, setShareModalShow, url, shareText, closeAction, addPaxWalletPop, setAddPaxWalletPop, hedingText }) => {
    const { showModal, showToast } = useContext(NotificationContext);
    const { userInfo } = useContext(UserContext);
    const { upgraeShowOpen ,setUpgraeShowOpen } = useContext(AppContext);
    const [PaxCount, setPaxCount] = useState(0)
        
        const ShowPendingAmount = () => {
            axios.post("payment/getAllPendingPaxByUserId", {
                userId: userInfo?.uid
            }).then((res: any) => {
                if (res?.data?.data?.result) {
                    setPaxCount(res?.data?.data?.result?.paxList.length)
                }
            }).catch((err: any) => {
                console.log(err, "resultdata")
            })
        }    
        
    console.log(PaxCount,"res?.data?.data?.result")
    useEffect(() => {
        if (!userInfo?.isUserUpgraded && !(userInfo?.miningPass?.expiryDate.seconds > moment().unix())) {
            ShowPendingAmount();
        }
    }, [userInfo?.uid, !userInfo?.isUserUpgraded,!userInfo?.miningPass?.isActive,])

    return (
        <div>
            <Modal
                className=""
                show={
                    shareModalShow
                } onHide={() => setShareModalShow(false)}
                // fullscreen="sm-down"
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                style={{ backgroundColor: "rgba(0,0,0,0.8)", zIndex: "2200" }}
                contentClassName={window.screen.width > 767 ? "card-content modulebackground" : "card-contentMob modulebackground"}
            >
                <div className="d-flex justify-content-end">
                    <button type="button" className="btn-close btn-close-white" aria-label="Close" onClick={() => {
                        setShareModalShow(false);  
                        if (setAddPaxWalletPop && !userInfo?.isUserUpgraded && !(userInfo?.miningPass?.expiryDate.seconds > moment().unix()) && upgraeShowOpen == false && PaxCount > 0) {                            
                            setTimeout(() => {
                                console.log(addPaxWalletPop, "setAddPaxWalletPop")
                                setAddPaxWalletPop(true)
                            }, 2000);
                        }

                        if (closeAction instanceof Function) {
                            closeAction();
                            
                        }
                    }}
                    // style={{color:"white" , border:"1px solid red"}}
                    >

                    </button>
                </div>
                <Modal.Body
                >
                    {/* continue voting */}
                    {/* @ts-ignore */}
                    <div className="d-flex justify-content-center my-3">
                        <strong className="mx-4" style={{ fontSize: '14px', textAlign: 'center', color: "white" }}>{hedingText?hedingText:"SHARE YOUR CARD NOW"}</strong>
                    </div>
                    <div className="d-flex  mt-3 mb-5 m-auto d-flex justify-content-center ">
                        <div className="mx-3">
                            <span
                                onClick={() => {
                                    copy(`${url}&refer=${userInfo?.userName}`);
                                    showToast(
                                        'Your Card link is copied to the clipboard.',
                                        ToastType.SUCCESS
                                    );
                                    
                                    // setTimeout(() => {
                                    //     console.log(addPaxWalletPop, "setAddPaxWalletPop")
                                    //     setAddPaxWalletPop(true)
                                    // }, 5000);
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                <Copy />
                            </span>
                        </div>

                        <div className="mx-3">
                            <I
                                className="bi-whatsapp"

                                onClick={() =>
                                    window.open(
                                        `https://api.whatsapp.com/send/?phone&text=${`${shareText} ${url}`.replace(
                                            " ",
                                            "+"
                                        )}&app_absent=0`,
                                        "_blank"
                                    )
                                }
                            />
                        </div>
                        <div className="mx-3">
                            {/* <I className="bi-twitter-x" /> */}
                            <img src={Xtwitter} alt="" width={"22px"}
                                onClick={() =>
                                    window.open(
                                        `https://twitter.com/intent/tweet?url=${url}?check_suite_focus=true&text=${shareText}`,
                                        "_blank"
                                    )
                                }
                            />
                        </div>
                        <div className="mx-3">
                            <I
                                className="bi bi-facebook"
                                onClick={() =>
                                    window.open(
                                        `https://www.facebook.com/sharer/sharer.php?u=${url}&t=${shareText}`,
                                        "_blank"
                                    )
                                }
                            />

                        </div>

                    </div>


                </Modal.Body>
            </Modal>
        </div >
    )
}

export default ShareModal